// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicEshopPaymentControllerCheckPaymentStatusData } from './PublicEshopPaymentControllerCheckPaymentStatusData.gen';
import type { PublicEshopPaymentControllerCheckPaymentStatusErrors } from './PublicEshopPaymentControllerCheckPaymentStatusErrors.gen';
import type { PublicEshopPaymentControllerCheckPaymentStatusResponses } from './PublicEshopPaymentControllerCheckPaymentStatusResponses.gen';

export class PublicEshopPaymentController {
    /**
     * Update payment state of order if changed.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_ACCOUNT_NOT_VERIFIED** - Customer account is not verified.<br>
     * + **INVALID_ORDER_STATE** - Eshop order state is invalid or does not exist.
     */
    public static checkPaymentStatus<ThrowOnError extends boolean = false>(options: Options<PublicEshopPaymentControllerCheckPaymentStatusData, ThrowOnError>) {
        return (options.client ?? client).put<PublicEshopPaymentControllerCheckPaymentStatusResponses, PublicEshopPaymentControllerCheckPaymentStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/payments/{id}/check',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
